import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { Button } from 'reactstrap';

import { userActions } from '../../../_actions';

import opptimise_logo_big from '../../../images/opptimise_logo_big.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import './login.css';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        this.props.dispatch(userActions.logout());

        this.state = {
            email: '',
            password: '',
            submitted: false,
            showMessage: false,
            incorrect_email: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value, incorrect_email: false });
    }

    componentDidMount() {
        this.setState({
            showMessage: false
        })
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { email, password } = this.state;
        const { dispatch } = this.props;
        const data = {
            email: email.toLowerCase(),
            password: password
        }
        
        if (/^[A-Za-z0-9](([_\.\+\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\+\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/.test(email) && password) {
            dispatch(userActions.login(data));
            this.setState({
                showMessage: true
            })
        }else {
            this.setState({
                incorrect_email: true
            })
        }
    }

    render() {
        const { alert } = this.props;
        const { loggingIn } = this.props;
        const { email, password, submitted, showMessage, incorrect_email } = this.state;
        return (
            <div className="login-page text-white">
                <div className="text-md-left py-3  px-md-5" style={{width: 'max-content'}}>
                    <div className="d-flex justify-content-center align-items-center py-2">
                        <img src={opptimise_logo_big} style={{width: 70}} />
                    </div>
                    <h5>Behavioral Analytics</h5>
                </div>

                <div className=" container pt-5">
                    <div className="d-flex flex-row justify-content-center">
                        <div className="col-lg-5 col-md-8 col-11 px-0">
                            <div className="login-field-page">
                                <p className="h4 text-center py-3 py-lg-2">LOGIN</p>

                                {
                                    showMessage ?   
                                        loggingIn ?
                                            <i className="w-100 text-center fa fa-spinner fa-spin"></i>
                                        :
                                            alert.message &&
                                                <p className="text-center">Invalid email ID or password</p>
                                    :
                                        null
                                }
                                <div className="">
                                    <form
                                        method="post"
                                        onSubmit={
                                            this.handleSubmit
                                        }
                                    >
                                        <div className="form-group">
                                            <label htmlFor="email" className="text-uppercase"><small>EMAIL ID</small></label>
                                            <input
                                                type="email" className="form-control" id="email" placeholder="name@company.com"
                                                name="email"
                                                required
                                                value={email}
                                                onChange={this.handleChange}
                                            />
                                            {submitted && !email &&
                                                <div className="help-block text-danger" style={{background: 'white',padding: '0.1rem 1rem', marginTop: '-5px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>Email is required</div>
                                            }
                                            {submitted && incorrect_email &&
                                                <div className="help-block text-danger" style={{background: 'white',padding: '0.1rem 1rem', marginTop: '-5px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>Email should be valid!</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="inputPassword4" className="text-uppercase"><small>Password</small></label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="inputPassword4"
                                                placeholder="Password"
                                                name="password"
                                                required
                                                value={password}
                                                onChange={this.handleChange}
                                            />
                                            {submitted && !password &&
                                                <div className="help-block text-danger" style={{background: 'white',padding: '0.1rem 1rem', marginTop: '-5px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>Password is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <div className="text-center">
                                                <Button
                                                    type="submit"
                                                    className="btn buttonColor text-white"
                                                    style={{padding: '0.3rem 1.5rem'}}
                                                    onClick={(e) => this.handleSubmit(e)}
                                                    disabled={!email || !password}
                                                >
                                                    Enter
                                                </Button>
                                            </div>
                                        </div>
                                        <p className="text-center "><Link className="text-white" to='login/forgot-password'> <small>Forgot Password?</small></Link></p>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        );
    }
}

function mapStateToProps(state) {
    const loggingIn = state.authentication.loggingIn ? true : false;
    const { alert } = state;
    return {
        loggingIn,
        alert
    };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage }; 


// WEBPACK FOOTER //
// ./src/_components/common/LoginPage/LoginPage.jsx